// utils/mergeMembersWithFees.js

/**
 * Merges members with their fee status from the league fees array
 * @param {Array} members - Array of league members
 * @param {Array} fees - Array of fee records from the LeagueModel
 * @param {Number} year - The year to match fee records (defaults to current year)
 * @returns {Array} members enriched with feesPaid property
 */
export function mergeMembersWithFees(members, fees, year = new Date().getFullYear()) {
  return members.map(member => {
    const feeRecord = fees.find(fee => 
      fee.userId?.toString() === member.userId?.toString() && fee.year === year
    );
      
    return {
      ...member,
      feesPaid: feeRecord ? feeRecord.paid : false, // Default to false if no record
    };
  });
}